<template>
  <div
    v-if="
      mentorLoggedIn ||
      menteeLoggedIn ||
      companyAdminLoggedIn ||
      superAdminLoggedIn
    "
  >
    <div class="entire_screen_div fix_font">
      <div class="entire_screen_div_child flex">
        <!-- Fixed navbar at top -->
        <!-- old outer div sidebar styling, remove class navbar_inner_div -->
        <!-- <div class="bg-purple w-64 h-screen sticky top-0 z-30 flex flex-col justify-between"> -->
        <div class="navbar_outer_div">

          <div class="navbar_inner_div">
            <!--This begins the code for the "getMentored.com" button you see at the top left-->
            <router-link
              v-if="menteeLoggedIn || mentorLoggedIn"
              to="/"
              class="flex items-center px-4 py-5 no-underline text-xl font-bold text-main"
            >
              GetMentored.com
            </router-link>

            <router-link
              v-if="companyAdminLoggedIn"
              to="/company-admin/dashboard"
              class="flex items-center px-4 py-5 no-underline text-xl font-bold text-main"
            >
              GetMentored.com
            </router-link>

            <router-link
              v-if="superAdminLoggedIn"
              to="/super-admin/dashboard"
              class="flex items-center px-4 py-5 no-underline text-xl font-bold text-main"
            >
              GetMentored.com
            </router-link>

            <!--This ends the code for the "getMentored.com" button you see at the top left-->

            <!-- OLD STYLING FOR SIDE BAR -->
            <!--<nav class="flex flex-col"> -->
            <nav class="flex items-center space-x-4">
              
              <!-- <div class="flex justify-center">
                <div class="nav-item">
                  <div v-if="menteeLoggedIn">Role: Mentee</div>
                  <div v-if="mentorLoggedIn">Role: Mentor</div>
                  <div v-if="superAdminLoggedIn">Role: SuperAdmin</div>
                  <div v-if="companyAdminLoggedIn">Role: Company Admin</div>
                </div>
              </div> -->

              <span
                class="nav-item text-gray-600 cursor-pointer"
                @click="go_to_company_page"
                v-if="companyAdminLoggedIn"
              >
                <!-- <span class="icon-circle"
                  ><img src="@/assets/logout.png" alt="Logout"
                /></span> -->
                Dashboard
              </span>

              <router-link
                v-if="superAdminLoggedIn"
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'super-admin-dashboard',
                  'text-gray-600': $route.name !== 'super-admin-dashboard',
                }"
                to="/super-admin/dashboard"
              >
                <!-- <span class="icon-circle">
                  <img src="@/assets/home.png" alt="Home"
                /></span> -->
                Admin Dashboard
              </router-link>

              <router-link
                v-if="mentorLoggedIn || menteeLoggedIn"
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'home',
                  'text-gray-600': $route.name !== 'home',
                }"
                to="/"
              >
                <!-- <span class="icon-circle"
                  ><img src="@/assets/home.png" alt="Home"
                /></span> -->
                Home
              </router-link>
              <router-link
                v-if="mentorLoggedIn || menteeLoggedIn"
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'sessions',
                  'text-gray-600': $route.name !== 'sessions',
                }"
                to="/sessions"
              >
                <!-- <span class="icon-circle"
                  ><img src="@/assets/sessions.png" alt="Sessions"
                /></span> -->
                Sessions
              </router-link>
              <router-link
                v-if="mentorLoggedIn || menteeLoggedIn"
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'calendar',
                  'text-gray-600': $route.name !== 'calendar',
                }"
                to="/mentee/calendar"
              >
                <!-- <span class="icon-circle"
                  ><img src="@/assets/calendar.png" alt="Calendar"
                /></span> -->
                Calendar
              </router-link>
              <router-link
                v-if="mentorLoggedIn || menteeLoggedIn"
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'assessment-landing-page',
                  'text-gray-600': $route.name !== 'assessment-landing-page',
                }"
                to="/assessment/landing-page"
              >
                <!-- <span class="icon-circle"
                  ><img src="@/assets/assessment.png" alt="Assessment"
                /></span> -->
                Assessment
              </router-link>
              <router-link
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'companies',
                  'text-gray-600': $route.name !== 'companies',
                }"
                to="/companies"
              >
                <!-- <span class="icon-circle"
                  ><img src="@/assets/companies.png" alt="Companies"
                /></span> -->
                Companies
              </router-link>
              <router-link
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'career',
                  'text-gray-600': $route.name !== 'career',
                }"
                to="/career"
              >
                <!-- <span class="icon-circle"
                  ><img src="@/assets/careers.png" alt="Careers"
                /></span> -->
                Careers
              </router-link>
              <router-link
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'mentors',
                  'text-gray-600': $route.name !== 'mentors',
                }"
                to="/mentors"
              >
                <!-- <span class="icon-circle"
                  ><img src="@/assets/mentors.png" alt="Mentors"
                /></span> -->
                Mentors
              </router-link>

            
              <!-- ADMIN ABILITIES DROP DOWN -->
              <!-- <div 
                @mouseenter="superAdminDropDownOpen = true"
                @mouseleave="superAdminDropDownOpen = false"
                class="relative text-gray-600"
                v-if="superAdminLoggedIn"
              > -->
                <!--Title-->
                <!-- <div class="flex items-center space-x-2 left-10">
                  <div 
                    
                    class="nav-item"
                  >
                    Admin Abilities
                  </div>

                  <svg class="w-3 h-3 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 8">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 5.326 5.7a.909.909 0 0 0 1.348 0L13 1"/>
                  </svg>
                </div> -->

                <!--Menu Items-->
                <!-- <div v-if="superAdminDropDownOpen" class="dropdown_menu_items">
                  <router-link
                    v-if="superAdminLoggedIn"
                    class="nav-item"
                    :class="{
                      'text-main': $route.name === 'super-admin-subscriptions',
                      'text-gray-600':
                        $route.name !== 'super-admin-subscriptions',
                    }"
                    to="/super-admin/subscriptions"
                  >
                    Subscriptions
                  </router-link>

                  <router-link
                    v-if="superAdminLoggedIn"
                    class="nav-item"
                    :class="{
                      'text-main': $route.name === 'super-admin-web-content',
                      'text-gray-600': $route.name !== 'super-admin-web-content',
                    }"
                    to="/super-admin/web-content"
                  >
                    Content Manager
                  </router-link>

                  <router-link
                    v-if="superAdminLoggedIn"
                    class="nav-item"
                    :class="{
                      'text-main': $route.name === 'super-admin-advertisements',
                      'text-gray-600':
                        $route.name !== 'super-admin-advertisements',
                    }"
                    to="/super-admin/advertisements"
                  >
                    Advertisement
                  </router-link>
                </div>
              </div> -->

              <router-link
                v-if="mentorLoggedIn || menteeLoggedIn"
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'videoLog',
                  'text-gray-600': $route.name !== 'videoLog',
                }"
                to="/videoLog"
              >
                <!-- <span class="icon-circle"
                  ><img src="@/assets/explore.png" alt="Explore Careers"
                /></span> -->
                Explore Careers
              </router-link>
            </nav>
          </div>

          <!-- Invite Mentor Button -->
          <router-link
            v-if="companyAdminLoggedIn"
            class="nav-item invite_mentor_button"
            :class="{
              'text-main': $route.name === 'company-admin-invite-mentors',
              'text-gray-600':$route.name !== 'company-admin-invite-mentors',
            }"
            to="/company-admin/invite-mentors"
          >
            Invite Mentors
          </router-link>

          <!-- Settings Dropdown menu -->
          <div 
            @mouseenter="settingsDropDownOpen = true"
            @mouseleave="settingsDropDownOpen = false"
            class="relative hover:scale-105"
          >
            <div class="flex items-center space-x-2 left-10">
              <!--Avatar Icon-->
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
              </svg>
              <!--Dropdown Arrow-->
              <svg class="w-3 h-3 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 8">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 5.326 5.7a.909.909 0 0 0 1.348 0L13 1"/>
              </svg>
            </div>

            <!-- Menu Items -->
            <div v-if="settingsDropDownOpen" class="dropdown_menu_items">
              <!--Profile-->
              <span
                class="nav-item text-gray-600 cursor-pointer"
                @click="go_to_mentor_page"
                v-if="mentorLoggedIn"
              >
                Profile
              </span>
              <!--Settings-->
              <router-link
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'settings',
                  'text-gray-600': $route.name !== 'settings',
                }"
                to="/settings"
                v-if="menteeLoggedIn"
              >
                Settings
              </router-link>
              <!--Logout-->
              <span
                class="nav-item"
                @click="logoutButtonClicked"
                v-if="
                  mentorLoggedIn ||
                  menteeLoggedIn ||
                  superAdminLoggedIn ||
                  companyAdminLoggedIn
                "
              >
                Logout
              </span>
            </div>
          </div>

        </div>
      
        <div class="flex-grow">
          <!-- Pushes content under nav -->
          <div class="mt-16">
            <!-- this is literally where the entire website is being rendered!-->
            <router-view :mode="mode" :key="$route.fullPath"></router-view>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- Not logged in -->
  <div v-else>
    <div>
      <div>
        <!-- Nav bar -->
        <header class="bg-white z-20 sticky top-0 px-16 pt-8 pb-4 font-primary">
          <div class="flex">
            <div class="flex items-center">
              <router-link
                to="/"
                class="no-underline text-xl font-bold text-main"
              >
                GetMentored.com
              </router-link>
            </div>
            <nav class="flex flex-row justify-end items-center grow">
              <!-- <router-link
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'assessment',
                  'text-alternate': $route.name !== 'assessment',
                }"
                to="/assessment/landing-page"
                v-if="mentorLoggedIn || menteeLoggedIn"
              >
                Assessment
              </router-link> -->

              <!-- Search Bar for Explore Careers-->

              <SearchBar v-if="$route.name === 'videoLog'" style="margin-right: 5px"/>

              <router-link
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'companies',
                  'text-alternate': $route.name !== 'companies',
                }"
                to="/companies"
              >
                Companies
              </router-link>

              <router-link
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'videoLog',
                  'text-alternate': $route.name !== 'videoLog',
                }"
                to="/videoLog"
              >
                Explore Careers
              </router-link>
              <router-link
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'career-finder',
                  'text-alternate': $route.name !== 'career-finder',
                }"
                to="/career"
              >
                Career Finder
              </router-link>
              <router-link
                class="nav-item"
                :class="{
                  'text-main': $route.name === 'mentors',
                  'text-alternate': $route.name !== 'mentors',
                }"
                to="/mentors"
              >
                Mentors
              </router-link>

              <router-link
                class="nav-item"
                to="/mentor/edit/profile"
                :class="{
                  'text-main': $route.name === 'mentor-profile',
                  'text-alternate': $route.name !== 'mentor-profile',
                }"
                v-if="mentorLoggedIn"
              >
                Profile
              </router-link>
              <router-link
                class="nav-item"
                to="/mentee/edit/profile"
                :class="{
                  'text-main': $route.name === 'mentee-profile',
                  'text-alternate': $route.name !== 'mentee-profile',
                }"
                v-if="menteeLoggedIn"
              >
                Profile
              </router-link>
              <router-link
                class="nav-item text-alternate cursor-pointer"
                to="/"
                custom
                v-slot="{ navigate }"
                v-if="mentorLoggedIn || menteeLoggedIn"
              >
                <span
                  @click="logoutButtonClicked"
                  @keypress.enter="navigate"
                  role="link"
                  >Logout</span
                >
              </router-link>
              <div v-if="!mentorLoggedIn && !menteeLoggedIn">
                <router-link to="/login">
                  <button class="secondary-button" style="margin-right: 14px; margin-left: 15px">
                    Log in
                  </button>
                </router-link>
                <router-link to="/register">
                  <button class="primary-button">Sign up</button>
                </router-link>
              </div>
            </nav>
          </div>
        </header>
        <!-- Router view -->
        <div>
          <router-view :mode="mode" :key="$route.fullPath"></router-view>
          <!-- Login Modal -->
          <footer class="px-16 pb-16 mt-4">
            <div style="display: flex;">
              <div class="secondary-text footer-text">
                Copyright GetMentored 2023 ©
              </div>
              <div 
                class="secondary-text footer-text about-text" 
                @click="navigateToAbout"
                >
                About
              </div>
            </div>
            <!-- <div>
              <i
                class="bi bi-instagram mr-2 cursor-pointer"
                @click="notYetImplemented"
              ></i>
              <i
                class="bi bi-linkedin cursor-pointer"
                @click="notYetImplemented"
              ></i>
            </div> -->
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueJwtDecode from "vue-jwt-decode";
import EventBus from "./eventbus";
import SearchBar from "./components/SearchBar.vue";
import {
  MENTOR_LOGIN,
  MENTEE_LOGIN,
  COMPANY_ADMIN_LOGIN,
  SUPER_ADMIN_LOGIN,
  LOGOUT,
  NAVIGATE_COMPANY_PAGE,
} from "./event";
import swal from "sweetalert";

export default {
  name: "App",
  components: {SearchBar},
  data() {
    return {
      mentorLoggedIn: false,
      menteeLoggedIn: false,
      companyAdminLoggedIn: false,
      superAdminLoggedIn: false,
      mode: "mentee",
      settingsDropDownOpen: false,
      superAdminDropDownOpen: false,
    };
  },
  created() {
    EventBus.$on(MENTOR_LOGIN, () => {
      this.mentorLoggedIn = true;
      this.mode = "mentor";
    });
    EventBus.$on(MENTEE_LOGIN, () => {
      this.menteeLoggedIn = true;
      this.mode = "mentee";
    });
    EventBus.$on(COMPANY_ADMIN_LOGIN, () => {
      this.companyAdminLoggedIn = true;
      this.mode = "company-admin";
    });
    EventBus.$on(SUPER_ADMIN_LOGIN, () => {
      this.superAdminLoggedIn = true;
      this.mode = "super-admin";
    });
    EventBus.$on(LOGOUT, () => {
      this.logout();
    });
    EventBus.$on(NAVIGATE_COMPANY_PAGE, async () => {
      await this.go_to_company_page();
    });
  },
  mounted() {
    this.tryRestoreSession();
  },
  methods: {
    logout() {
      localStorage.removeItem("mentor-jwt");
      localStorage.removeItem("mentee-jwt");
      localStorage.removeItem("company-admin-jwt");
      localStorage.removeItem("super-admin-jwt");

      this.mentorLoggedIn = false;
      this.menteeLoggedIn = false;
      this.superAdminLoggedIn = false;
      this.companyAdminLoggedIn = false;

      try {
        this.$router.push("/landing").catch(() => {}); // Explicitly redirect to landing page
      } catch (error) {
        console.log(error);
      }
    },
    logoutButtonClicked() {
      this.logout();
      swal("Success", "Logout Successful", "success");
    },
    navigateToAbout() {
      this.$router.push("/about").catch(() => {});
    },
    tryRestoreSession() {
      this.tryRestoreMentorSession();
      this.tryRestoreMenteeSession();
      this.tryRestoreCompanyAdminSession();
      this.tryRestoreSuperAdminSession();
    },
    tryRestoreMentorSession() {
      if (localStorage.getItem("mentor-jwt")) {
        EventBus.$emit(MENTOR_LOGIN);
      }
    },
    tryRestoreMenteeSession() {
      if (localStorage.getItem("mentee-jwt")) {
        EventBus.$emit(MENTEE_LOGIN);
      }
    },
    tryRestoreCompanyAdminSession() {
      if (localStorage.getItem("company-admin-jwt")) {
        EventBus.$emit(COMPANY_ADMIN_LOGIN);
      }
    },
    tryRestoreSuperAdminSession() {
      if (localStorage.getItem("super-admin-jwt")) {
        EventBus.$emit(SUPER_ADMIN_LOGIN);
      }
    },
    notYetImplemented() {
      swal("Error", "Not yet implemented!", "error");
    },
    // we will assume that if they can click on the dashboard button, then are logged into their companyAdmin account and
    // we can redirect to the company page
    async go_to_company_page() {
      const token = localStorage.getItem(`company-admin-jwt`);
      const user = await this.get_user_profile(token);
      const companyId = user.company_id;
      // console.log("=======================" + companyId);
      this.$router.push("/company/" + companyId).catch(() => {});
    },
    async get_company(companyID) {
      const result = await this.$http.get(`/company/${companyID}`);
      return result.data;
    },
    async go_to_mentor_page() {
      const token = localStorage.getItem(`mentor-jwt`);
      const decoded = VueJwtDecode.decode(token);
      // console.log("=======================" + decoded.id);
      this.$router.push("/mentor/profile/" + decoded.id).catch(() => {});
    },
    async get_user_profile(userToken) {
      return (
        await this.$http.get(`/user/profile`, {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        })
      ).data;
    },
  },
};
</script>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;

.nav-item {
  @apply flex items-center px-2 py-2 no-underline font-bold text-gray-600 hover:text-[#6AA67C] text-base;
}
/* not used */
.nav-item-2 {
  @apply flex items-center px-0 py-0 no-underline font-semibold text-gray-600 bg-customPurple hover:bg-customLightPurple text-base;
}

.fix_font {
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  color: #000000;
  font-weight: 10000;
}

.icon-circle {
  @apply inline-flex justify-center items-center mr-2;
  width: 35px;
  height: 35px;
  background-color: #eee;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10%;
}

.icon-circle img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  object-fit: cover;
}

.icon-circle i {
  font-size: 12px;
  color: #333;
}

.footer-text {
  font-weight: 800;
  font-size: 12px;
  margin-bottom: 0.5rem;
  font: montserrat;
}

.footer-logo {
  padding-right: 10px;
}

.app-modal {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

/*
 The reason for the styling below is to identify which div containers are on the screen.
 These will be commented out but will help anyone identify where each container is.
 Uncomment them when needed!!
*/
/* .navbar_inner_div{
  border: 5px solid red;
}

.navbar_outer_div{
  border: 5px solid blue;
}
.entire_screen_div{
  border: 10px dashed green
}
.entire_screen_div_child{
  border: 10px dashed black
} */

/* Below I will place the styling related to admin abilities*/

.admin_ability_title_text {
  margin-top: 50px;
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  color: rgb(75, 85, 99);
  font-weight: 700;
  display: flex; /* Enable flexbox */
  flex-direction: column; /* Align buttons in a column */
  align-items: center;
}
.admin_abilities_panel {
  padding: 32px;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 10px;
  background-color: rgba(221, 217, 255, 1);
  box-shadow: -10px 10px 10px -5px rgba(0, 0, 0, 0.5);
  display: flex; /* Enable flexbox */
  flex-direction: column; /* Align buttons in a column */
  margin-bottom: 50px;
  align-items: center;
}
.invite_mentor_abilities_panel {
  border: 2px solid black;
  margin-top: 30px;
  padding: 20px;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 10px;
  background-color: rgba(221, 217, 255, 1);
  box-shadow: -10px 10px 10px -5px rgba(0, 0, 0, 0.5);
  display: flex; /* Enable flexbox */
  flex-direction: column; /* Align buttons in a column */
  margin-bottom: 50px;
  align-items: center;
}

/* .subscriptions-item{
  border: 5px solid black;
} */

.subscription_button {
  padding: 10px;
  color: white;
}
.content_manager_button {
  padding: 10px;
  color: white;
}
.advertisment_button {
  padding: 10px;
  color: white;
}

.navbar_outer_div{
  background-color: white;
  width: 100%;
  height: 4rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 1rem;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.navbar_inner_div{
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

nav{
  width: 80%;
  margin-left: auto;
}

/* not used */
.nav-item-2 {
  border-radius: 5px; 
  font-size: 15px; 
  width: 180px; 
  align-items: center;
  justify-content: center;
} 

.identify_1 {
  border: 10px dashed blue;
}

.invite_mentor_button {
  color: #6c5fe0;
  background-color: white;
  border: 2px solid #6c5fe0;
  padding: 6px 10px;
  border-radius: 6px;
  margin-left: auto;
  margin-right: 35px;
}

.invite_mentor_button:hover{
  background-color: #6c5fe0;
  color: white;
}

.dropdown_menu_items{
  position: absolute;
  right: 0;
  background-color: white;
  color: lightgray; 
  border-radius: 2px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.about-text{
  padding-left: 50px; 
  cursor: pointer;
}

.about-text:hover{
  color: #545F71;
}


</style>
